import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Icon1 from "../../icons/Icon";
import Space from "../../layout/Space";

import Row from "../../layout/Row";
import Divider from "../../layout/Divider";
import { useEffect } from "react";
import changeFolderState from "../../api/folder/changeFolderState";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";
import { getAuthCentral } from "../../config/FirebaseConfig";
import downloadFolder from "../../api/download/downloadFolder";
import setFolderIntervention from "../../api/folder/setFolderIntervention";
import loginAs from "../../api/loginAs";
import { DatePicker, Spin, TimePicker } from "antd";
import { isFirstDayOfMonth, set } from "date-fns";
import { format } from "date-fns";
import { useState } from "react";
import dayjs from "dayjs";
import { useSnackbar } from "notistack";
import modifThermal from "../../api/folder/modifThermal";
import unlockRapport from "../../api/folder/unlockRapport";
import moment from "moment";
import sendInfiltreaGetReports from "../../api/infiltrea/sendInfiltreaGetReports";
import { Timestamp } from "firebase/firestore";
import { useAppContext } from "../../config/AppContext";
import RevisiteModal from "../../folder_modals/Revisite";
import Revisite from "../../folder_modals/Revisite";
import Modal1 from "../../modals/Modal1";
import {
  getDateFromFlutter,
  getDocDataByRef,
  getFlutterTime,
  getFlutterTimeFromSeconds,
  getFlutterTimeFromSecondsFormatDate,
  getOrgDataById,
  last_of_list,
  queryCollection,
  updateDocDataField,
} from "../../models/DataFunctions";
import refreshCounters from "../../api/refreshCounters";
import sendRTBatiment from "../../api/send/sendRTBatiment";
import TimedProgressBar from "../../loading/TimedProgressBar";
import RTBModal from "../../folder_modals/RTBModal";
import Convert from "../../folder_modals/Convert";
import ModifThermique from "../../folder_modals/ModifThermique";
import sendExtractXml from "../../api/send/sendExtractXml";
import NewMission from "../../infiltrea/NewMission";
import SecondaryButton from "../../buttons/SecondaryButton";
import WarningButton from "../../buttons/WarningButton";
import RDV from "../../folder_modals/RDV";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi";
import sendConformityReport from "../../api/send/sendConformityReport";
import { name } from "dayjs/locale/fr";
import createDocApi from "../../api/database/createDocApi";
import SmallSpinner from "../../loading/SmallSpinner";
import { PremiumBar } from "../../hexagone/ParametersNavBar";
import TextField2 from "../../textfields/TextField2";
import Conformity from "../../folder_modals/Conformity";
import sendNotificationParticulier from "../../api/sign/sendNotificationParticulier";
import RangeTimePickerGPT0 from "../../textfields/RangeTimePickerGPT0";
import { range } from "@mui/x-data-grid/internals";
import { addActivityLog } from "../../config/OnlineStatus";
import { EasySwitch } from "../../textfields/EasySwitch";
import FacturePennylane from "../../folder_modals/FacturePennylane";
import DatePickerGPT0 from "../../textfields/DatePickerGPT0";
import updateDocApi from "../../api/database/updateDocApi";
import {
  isFolderAdmin,
  isFolderAdminOrClient,
  isFolderClient,
} from "./FolderHelpers";
import PrimaryButton from "../../buttons/PrimaryButton";
import { particulierActivated } from "../../hexagone/VisibilityHelpers";
import Intermediary from "../../folder_modals/Intermediary";
import AddTask from "../../folder_modals/AddTask";
import { addCarnet } from "../../api/add/addCarnet";
import {
  canCreateCarnet,
  folderHasCarnet,
  hasAccessToCarnet,
} from "../../hexagone_logement/utils";
import ConvertBasic from "../../folder_modals/ConvertBasic";
import AiExcelComparatif from "../../folder_modals/AiExcelComparatif";
import AiExtractionInvoice from "../../folder_modals/AiExtractionInvoice";
import CheckBoxGrey from "../../textfields/CheckBoxGrey";
import { getArrayDocDataByID } from "../../models/DataFunctions";
import DepotCILModal from "../../components/DepotCILModal";
import PartnerSelectionModal from "../../folder_modals/PartnerSelectionModal";

const xmlMode = {
  NORMAL: "normal",
  MAJ: "maj",
};

export default function FoldersAM({
  stick_left = false,
  userData,
  orgData,
  actionModify,
  actionDelete,

  all_repertories,
  setAllRepertories,
  workspaceData,
  folder,
  forcePageReload,
  loadingDelete,
  handleSetEmailModalOpen,
  navigateWorkspace,
  masterData,
  handleSetReglementDone,
  carnetDetails = null,
  setMissingDocNames,
  setMissingDocIds,
}) {
  const [selectedXmlMode, setSelectedXmlMode] = useState(xmlMode.NORMAL);
  const [subMenuAnchorEl, setSubMenuAnchorEl] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [vision, setVision] = React.useState(null);
  const [date, setDate] = useState("../../....");
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [display_rdv_tuto, setDisplayRDVTuto] = useState(
    workspaceData && Math.random() > 0.7
  );
  const [infiltreaOpen, setInfiltreaOpen] = useState(false);
  const [revisiteOpen, setRevisiteOpen] = useState(false);
  const [conformityOpen, setConformityOpen] = useState(false);
  const [intermediaryOpen, setIntermediaryOpen] = useState(false);
  const [rdvopen, setRDVOpen] = useState(false);
  const [taskOpen, setTaskOpen] = useState(false);
  const open = Boolean(anchorEl);
  const [excelComparatifOpen, setAiExcelComparatifOpen] = useState(false);
  const [aiExtractionInvoiceOpen, setAiExtractionInvoiceOpen] = useState(false);
  const [docRequestOpen, setDocRequestOpen] = useState(false);
  const [folderDocuments, setFolderDocuments] = useState([]);
  const [localMissingDocNames, setLocalMissingDocNames] = useState([]);
  const [localMissingDocIds, setLocalMissingDocIds] = useState([]);
  const [depotCILOpen, setDepotCILOpen] = useState(false);
  const [partnerSelectionOpen, setPartnerSelectionOpen] = useState(false);
  const handleSubMenuOpen = (event) => {
    setSubMenuAnchorEl(event.currentTarget);
  };

  const handleSubMenuClose = () => {
    setSubMenuAnchorEl(null);
  };

  const actionDuplicate = async () => {
    navigateWorkspace(`/newfolder?duplicate_folder_id=${folder.id}`);
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleInfiltreaSetOpen = (value) => {
    setInfiltreaOpen(value);
    setAnchorEl(null);
    forcePageReload();
  };

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const handleArchive = async (target = "me") => {
    let visions = folder.visions;
    for (let i = 0; i < visions.length; i++) {
      if (target === "me" && visions[i]["org_id"] !== orgData.id) {
        continue;
      }
      visions[i]["state"] = "archived";
    }
    await updateDocDataFieldApi(folder.ref, "visions", visions, prefix);

    if (vision) {
      vision.state = "archived";
      setVision(vision);
    } else {
      setVision({
        org_id: orgData.id,
        state: "archived",
      });
    }

    handleClickVariant("Dossier archivé", "success");
    setAnchorEl(null);
    forcePageReload();
  };

  const handleUnarchive = async (target = "me") => {
    let visions = folder.visions;
    for (let i = 0; i < visions.length; i++) {
      if (target === "me" && visions[i]["org_id"] !== orgData.id) {
        continue;
      }
      visions[i]["state"] = "current";
    }
    await updateDocDataFieldApi(folder.ref, "visions", visions, prefix);

    if (vision) {
      vision.state = "current";
      setVision(vision);
    } else {
      setVision({
        org_id: orgData.id,
        state: "current",
      });
    }

    handleClickVariant("Dossier désarchivé", "success");
    setAnchorEl(null);
    forcePageReload();
  };

  const handleNavigateCarnet = async () => {
    // Check if user has access to carnet
    const hasAccess = await hasAccessToCarnet(orgData, carnetDetails);
    if (!hasAccess) {
      handleClickVariant("Vous n'avez pas accès à ce carnet", "error");
      return;
    }

    try {
      // Get current user's ID token and UID
      const auth = getAuthCentral();
      const idToken = await auth.currentUser.getIdToken();
      const uid = auth.currentUser.uid;

      // Get custom token from backend for hexagone_logement
      const customToken = await loginAs(uid, idToken, prefix);

      if (customToken) {
        // Pass custom token in URL for automatic login on the other domain
        window.open(
          `https://logement.hexagone.expert/carnet/${folder.carnet_id}?authToken=${customToken}`
        );
      } else {
        // Fallback: open without token
        console.error("Failed to get custom token");
        window.open(
          `https://logement.hexagone.expert/carnet/${folder.carnet_id}`
        );
      }
    } catch (error) {
      console.error("Error getting auth token:", error);
      // Fallback: open without token
      window.open(
        `https://logement.hexagone.expert/carnet/${folder.carnet_id}`
      );
    }
  };

  const handleAddCarnet = async () => {
    // Check if folder has partners in visions (excluding master and particulier)
    const partnerOrgIds = folder.visions
      ? folder.visions
          .map((vision) => vision.org_id)
          .filter(
            (orgId) => orgId !== folder.master_id && orgId !== "particulier"
          )
      : [];

    if (partnerOrgIds.length > 0) {
      setPartnerSelectionOpen(true);
      setAnchorEl(null);
    } else {
      // No partners, proceed directly
      await createCarnet([]);
    }
  };

  const createCarnet = async (selectedPartnerIds) => {
    setLoadingCarnet(true);
    const startTime = Date.now();
    const minLoadingTime = 3000; // 3 seconds minimum

    try {
      const token = await getOrRefreshFirebaseToken();
      await addCarnet(folder.id, token, prefix, selectedPartnerIds);

      // Ensure minimum loading time
      const elapsedTime = Date.now() - startTime;
      const remainingTime = minLoadingTime - elapsedTime;
      if (remainingTime > 0) {
        await new Promise((resolve) => setTimeout(resolve, remainingTime));
      }

      handleClickVariant("Carnet ajouté au dossier", "success");
    } catch (error) {
      console.error("Error adding carnet:", error);
      handleClickVariant("Erreur lors de l'ajout du carnet", "error");
    } finally {
      setLoadingCarnet(false);
      setPartnerSelectionOpen(false);
      forcePageReload();
    }
  };

  const [loadingDownload, setLoadingDownload] = useState(false);
  const [loadingCarnet, setLoadingCarnet] = useState(false);
  const handleDownload = async () => {
    setLoadingDownload(true);
    await downloadFolder(folder.ref, folder.nom);
    setAnchorEl(null);
    handleClickVariant("Téléchargement en cours", "info");
    setLoadingDownload(false);
  };
  const handleTagRevision = async (add = true) => {
    let revisions = folder.revisions;
    if (add) {
      if (revisions === null || revisions === undefined) {
        await updateDocDataFieldApi(folder.ref, "revisions", [], prefix);
        handleClickVariant("Revisite prévue", "success");
      } else {
      }
    } else {
      await updateDocDataFieldApi(folder.ref, "revisions", null, prefix);
    }

    forcePageReload();
    setAnchorEl(null);
  };

  const handleRevision = (value) => {
    setRevisiteOpen(value);
    setAnchorEl(null);
    forcePageReload();
  };

  const handleModifTherm = (value) => {
    setModifThermOpen(value);
    setAnchorEl(null);
    forcePageReload();
  };

  const handleConformity = (value) => {
    setConformityOpen(value);
    setAnchorEl(null);
    forcePageReload();
  };

  const handleRDV = async (value) => {
    setRDVOpen(value);
    setAnchorEl(null);
    forcePageReload();
  };

  const handleNonConforme = async () => {
    if (folder.conforme === false) {
      await updateDocDataFieldApi(folder.ref, "conforme", true, prefix);
      await addActivityLog(
        "Dossier passé en conforme",
        folder.ref,
        orgData.id,
        userData.id,
        "folder_marqued_as_conforme",
        prefix
      );
      handleClickVariant("Dossier conforme", "success");
    } else {
      await updateDocDataFieldApi(folder.ref, "conforme", false, prefix);
      await addActivityLog(
        "Dossier passé en non conforme",
        folder.ref,
        orgData.id,
        userData.id,
        "folder_marqued_as_non_conforme",
        prefix
      );
      handleClickVariant("Dossier non conforme", "success");
    }
    forcePageReload();
    setAnchorEl(null);
  };

  const handleUnlockRapport = async () => {
    handleSetReglementDone();

    setAnchorEl(null);

    //forcePageReload();
  };
  const [loadingUnlock, setLoadingUnlock] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedTime2, setSelectedTime2] = useState(null);

  // Handlers for date and time changes
  const handleDateChange = (seconds) => {
    setSelectedDate(getFlutterTimeFromSeconds(seconds));
  };

  const [rangeTime, setRangeTime] = useState({
    start_seconds: null,
    end_seconds: null,
  });
  const handleTimeRangeChange = (timeRange) => {
    if (timeRange) {
      setRangeTime(timeRange);
    }
  };
  const actionConvert = () => {
    setConvertOpen(true);
    setAnchorEl(null);
  };

  const handleCreateInfitreaMission = async () => {
    setInfiltreaOpen(true);
    setAnchorEl(null);
  };

  const [FacturePennylaneOpen, setFacturePennylaneOpen] = useState(false);
  const handleRTBatiment = async () => {
    setAnchorEl(null);
    setRTBOpen(true);
  };

  const handleFacturePennylane = async () => {
    if (!orgData.pennylane?.connected === true) {
      handleClickVariant(
        "Vous n'avez pas activé l'intégration à Pennylane",
        "error"
      );
      navigateWorkspace("/pennylane");
    }
    setFacturePennylaneOpen(true);
    setAnchorEl(null);
  };

  const handleAiExcelComparatif = async () => {
    setAiExcelComparatifOpen(true);
    setAnchorEl(null);
  };
  const handleAiExtractionInvoice = async () => {
    setAiExtractionInvoiceOpen(true);
    setAnchorEl(null);
  };

  const handleDocumentRequest = async () => {
    // Load ALL folder documents
    if (folder.documents && folder.documents.length > 0) {
      const documents = await getArrayDocDataByID(
        "document",
        folder.documents.map((doc) => doc.id)
      );
      setFolderDocuments(documents);
    }
    setDocRequestOpen(true);
    setAnchorEl(null);
  };

  const handleDocumentSelectionConfirm = () => {
    setDocRequestOpen(false);
    // Update the global missing doc names and IDs state
    setMissingDocNames(localMissingDocNames);
    setMissingDocIds(localMissingDocIds);
    // Pass the document names and IDs directly to the email modal handler

    handleSetEmailModalOpen(
      true,
      false,
      true,
      localMissingDocNames,
      localMissingDocIds
    );
  };

  const handleSetInterventionRealisee = async () => {
    const token = await getOrRefreshFirebaseToken();

    const intervention_time_int = folder.dateintervention?.seconds || 0;
    const interventiondone = true;

    await updateDocDataFieldApi(
      folder.ref,
      "intervention_realisee",
      true,
      prefix
    );
    await updateDocDataFieldApi(
      folder.ref,
      "intervention_time_int",
      intervention_time_int,
      prefix
    );
    handleClickVariant("Intervention réalisée", "success");
    setAnchorEl(null);
    forcePageReload();
  };
  const [loadingCreateEvent, setLoadingCreateEvent] = useState(false);
  const createEvent = async () => {
    if (loadingCreateEvent) return;

    setLoadingCreateEvent(true);
    if (!folder.dateintervention) {
      handleClickVariant(
        "Le dossier choisi n'a pas de date d'intervention",
        "error"
      );
      setLoadingCreateEvent(false);
      return;
    } else {
      // end should be start + 1 hour and start is a timestamps
      let start = folder.dateintervention;

      let client;
      if (folder.client_id) {
        client = await getOrgDataById(folder.client_id);
      }
      let end = getFlutterTimeFromSeconds(
        folder.dateintervention.seconds + 3600
      );
      let body = {
        start: start,
        end: end,
        name: folder.nom,
        master_id: folder.master_id,
        client_name: folder.marque || client?.name,
        folder: folder.ref,
        client_type: folder.client_type,
        members: folder.members_id,
        pack_name: folder.pack_name,
        pack_ref: folder.pack_ref,
        ville: folder.ville,
        title: folder.nom,
        type: "Intervention",
      };
      await createDocApi("event", body, prefix);
      handleClickVariant("Evènement créé", "success");
      setLoadingCreateEvent(false);
    }
  };

  const handleSetInterventionNOTRealisee = async () => {
    const token = await getOrRefreshFirebaseToken();
    await updateDocDataFieldApi(
      folder.ref,
      "intervention_realisee",
      false,
      prefix
    );
    await updateDocDataFieldApi(folder.ref, "intervention_time_int", 0, prefix);
    await updateDocDataFieldApi(folder.ref, "dateintervention", null, prefix);
    handleClickVariant("Intervention non réalisée", "success");
    setDatePicker(false);

    setAnchorEl(null);
    forcePageReload();
  };

  const handleDeleteInterventionDate = async () => {
    await updateDocApi(
      folder.ref,
      { dateintervention: null, intervention_time_int: 0 },
      prefix
    );

    handleClickVariant("Date d'intervention supprimée", "success");
    setAnchorEl(null);
    setDatePicker(false);
    forcePageReload();
  };
  const [loadingSave, setLoadingSave] = useState(false);
  const handleSetInterventionRealisee2 = async (setDone) => {
    setLoadingSave(true);
    const token = await getOrRefreshFirebaseToken();
    let date = dayjs.unix(selectedDate.seconds);
    let selectedDate_with_no_hours = date.startOf("day");
    if (!rangeTime.start_seconds || !rangeTime.end_seconds) {
      handleClickVariant(
        "Veuillez sélectionner une heure de début et de fin",
        "error"
      );
      return;
      setLoadingSave(false);
    }
    const selectedTime = rangeTime.start_seconds;
    const selectedTime2 = rangeTime.end_seconds;

    // Combine the date and time into a single Unix timestamp
    const intervention_time_int =
      selectedDate_with_no_hours.unix() + selectedTime;

    // check if the selected date if after today
    let interventiondone = false;

    if (intervention_time_int < dayjs().startOf("day").unix()) {
      interventiondone = true;
    } else {
      interventiondone = false;
    }

    let new_start = getFlutterTimeFromSeconds(intervention_time_int);
    let new_end = getFlutterTimeFromSeconds(intervention_time_int + 3600);

    await updateDocApi(
      folder.ref,
      {
        intervention: {
          start: new_start,
          end: new_end,
        },
        dateintervention: getFlutterTimeFromSeconds(intervention_time_int),
        intervention_realisee: interventiondone,
      },
      prefix
    );

    if (folder.event_ref) {
      const event = await getDocDataByRef(folder.event_ref);
      if (event) {
        await updateDocDataFieldApi(event.ref, "start", new_start, prefix);
        await updateDocDataFieldApi(event.ref, "end", new_end, prefix);
      }
    }

    handleClickVariant("Date d'intervention modifiée", "success");
    setAnchorEl(null);
    forcePageReload();
    setDatePicker(false);
    setLoadingSave(false);
  };

  const handleNotifyParticulier = async () => {
    if (!folder?.reglement?.infos?.phone) {
      handleClickVariant("Aucun numéro de téléphone enregistré", "error");
      return;
    }
    const token = await getOrRefreshFirebaseToken();
    await sendNotificationParticulier(folder.id, token, prefix);
    handleClickVariant("Notification envoyée", "success");
    setAnchorEl(null);
    forcePageReload();
  };

  const handleValidateAll = async () => {
    try {
      // Filter and process documents in parallel
      const updatePromises = folder.documents.map(async (docRef) => {
        const doc = await getDocDataByRef(docRef);
        if (doc.state === "wait") {
          return updateDocDataFieldApi(docRef, "state", "done", prefix);
        }
      });

      // Wait for all updates to complete
      await Promise.all(updatePromises);

      // Notify the user and handle UI updates
      handleClickVariant("Tous les documents ont été validés", "success");
      setAnchorEl(null);
      forcePageReload();
    } catch (error) {
      // Handle any errors that occur during processing
      console.error("Error validating documents:", error);
      handleClickVariant("Erreur lors de la validation des documents", "error");
    }
  };

  const actionRefreshCounters = async () => {
    const token = await getOrRefreshFirebaseToken();
    await refreshCounters(token, folder.id, prefix);
    handleClickVariant("Actions mises à jour", "success");
    setAnchorEl(null);
    forcePageReload();
  };

  const handleChangeInterventionDate = async () => {
    setDatePicker(true);
    setIsPickingDate(true);
    setAnchorEl(null);
  };

  const handleExtractXml = async () => {
    const token = await getOrRefreshFirebaseToken();
    await sendExtractXml(folder.id, token, prefix);
    handleClickVariant(
      "Données disponibles sur l'application mobile",
      "success"
    );
    setAnchorEl(null);
  };

  const [isPickingDate, setIsPickingDate] = useState(false);
  const [isPickingDate2, setIsPickingDate2] = useState(false);

  const [datepicker, setDatePicker] = React.useState(false);
  const [datepicker2, setDatePicker2] = React.useState(false);

  const [rtb_open, setRTBOpen] = useState(false);
  const [convertOpen, setConvertOpen] = useState(false);
  const [modifThermOpen, setModifThermOpen] = useState(false);

  const [confirm_text, setConfirmText] = useState("");

  const [openDelete, setOpenDelete] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(open);
  }, [open]);

  useEffect(() => {
    if (orgData && folder) {
      const vision = folder.visions.filter(
        (vision) => vision.org_id === orgData.id
      )[0];
      setVision(vision);
      setSelectedDate(folder.dateintervention);
      setSelectedTime(
        dayjs(
          folder.intervention?.start?.seconds
            ? dayjs(folder.intervention?.start?.seconds * 1000)
            : null
        )
      );
      folderHasCarnet;
      setSelectedTime2(
        folder.intervention?.end?.seconds
          ? dayjs(folder.intervention?.end?.seconds * 1000)
          : null
      );
    }
  }, [orgData, folder]);

  return (
    <div className="relative">
      {display_rdv_tuto && false && (
        <div className="absolute top-8 animate-tiny-bounce hover:animate-none items-center right-0 w-fit shadow-2xl shadow-blue-300 bg-white p-6 rounded-2xl text-shadow_50 flex flex-row gap-2">
          <div className="text-h3 w-c300">
            Demandez un rendez-vous en allant dans Actions {" >> "} Demander un
            RDV
          </div>
          <div
            className="cursor-pointer "
            onClick={() => {
              setDisplayRDVTuto(false);
            }}
          >
            <Icon1
              hover_color={"red"}
              icon_name="close"
              size={20}
              fill="grey"
            ></Icon1>
          </div>
        </div>
      )}
      <Modal1 isOpen={datepicker} onClose={() => setDatePicker(false)}>
        <div className=" flex flex-col bg-white rounded-xl ">
          <div className="flex flex-row justify-between p-4 border-b-1">
            <div className="text-h2">Changer la date</div>
            <div
              onClick={() => setDatePicker(false)}
              className=" cursor-pointer text-h3 text-shadow_50 "
            >
              Fermer
            </div>
          </div>
          <div className="flex flex-col gap-3 p-4 bg-neutral-50">
            <DatePickerGPT0
              seconds={selectedDate?.seconds}
              onChange={handleDateChange}
              label="Sélectionner la date"
              transparent={false}
              getPopupContainer={(triggerNode) => triggerNode.parentNode} // Render dropdown relative to the modal
            />

            <RangeTimePickerGPT0
              onChange={handleTimeRangeChange}
              value={rangeTime}
              transparent={false}
            ></RangeTimePickerGPT0>
          </div>
          <div className="flex flex-row  gap-2 border-t-1 p-4">
            <SecondaryButton
              className="w-fit"
              onClick={handleDeleteInterventionDate}
            >
              Supprimer date d'intervention
            </SecondaryButton>{" "}
            <PrimaryButton
              className="w-fit"
              onClick={() => handleSetInterventionRealisee2(false)}
            >
              Confirmer {loadingSave && <SmallSpinner></SmallSpinner>}
            </PrimaryButton>
          </div>
        </div>
      </Modal1>
      <Modal1 isOpen={openDelete} onClose={() => setOpenDelete(false)}>
        <div className=" flex flex-col bg-white rounded-xl p-4">
          <div className="text-h2">
            Voulez-vous vraiment supprimer cet élément ?
          </div>
          <div className="text-h3 text-shadow_50 my-4">
            Cette action est <span className="text-red-500">irréversible</span>.
          </div>
          <div className="text-h3 text-shadow_50 mb-4">
            Elle entraîne la suppression définitive de ces éléments.
          </div>
          <div className="text-h3 text-shadow_50 ">- Dossier</div>
          <div className="text-h3 text-shadow_50 ">- Messages</div>
          <div className="text-h3 text-shadow_50 ">- Devis</div>
          <div className="text-h3 text-shadow_50 ">- Evènements</div>
          <div className="text-h3 text-shadow_50 my-4">
            Entrez CONFIRMER pour confirmer la suppression.
          </div>
          <TextField2
            label="CONFIRMER"
            value={confirm_text}
            onChange={(e) => setConfirmText(e.target.value)}
          ></TextField2>
          <Space y={20} />
          {!loadingDelete && (
            <div className="flex flex-row justify-end gap-2 ">
              <SecondaryButton onClick={() => setOpenDelete(false)}>
                Annuler
              </SecondaryButton>
              <WarningButton
                disabled={confirm_text != "CONFIRMER"}
                onClick={actionDelete}
              >
                Supprimer
              </WarningButton>
            </div>
          )}
          {loadingDelete && <SmallSpinner></SmallSpinner>}
        </div>
      </Modal1>
      <Modal1 isOpen={infiltreaOpen} onClose={() => setInfiltreaOpen(false)}>
        <NewMission
          document={document}
          folder={folder}
          orgData={orgData}
          onClose={() => setInfiltreaOpen(false)}
          onUpdate={forcePageReload}
        />
      </Modal1>
      <Modal1
        isOpen={rtb_open}
        onClose={() => {
          setRTBOpen(false);
        }}
      >
        <RTBModal
          forcePageReload={forcePageReload}
          onClose={() => {
            setRTBOpen(false);
          }}
          navigateWorkspace={navigateWorkspace}
          userData={userData}
          orgData={orgData}
          folderData={folder}
        ></RTBModal>
      </Modal1>
      <Modal1
        isOpen={FacturePennylaneOpen}
        onClose={() => {
          setFacturePennylaneOpen(false);
        }}
      >
        <FacturePennylane
          folderData={folder}
          forcePageReload={forcePageReload}
          onClose={() => {
            setFacturePennylaneOpen(false);
            forcePageReload();
          }}
          navigateWorkspace={navigateWorkspace}
          orgData={orgData}
          userData={userData}
        ></FacturePennylane>
      </Modal1>
      <Modal1
        isOpen={excelComparatifOpen}
        onClose={() => {
          setAiExcelComparatifOpen(false);
        }}
      >
        <AiExcelComparatif
          folderData={folder}
          forcePageReload={forcePageReload}
          onClose={() => {
            setAiExcelComparatifOpen(false);
            forcePageReload();
          }}
          navigateWorkspace={navigateWorkspace}
          orgData={orgData}
          userData={userData}
        ></AiExcelComparatif>
      </Modal1>
      <Modal1
        isOpen={aiExtractionInvoiceOpen}
        onClose={() => {
          setAiExtractionInvoiceOpen(false);
          forcePageReload();
        }}
      >
        <AiExtractionInvoice
          extraction_mode={true}
          folderData={folder}
          forcePageReload={forcePageReload}
          onClose={() => {
            setAiExtractionInvoiceOpen(false);
            forcePageReload();
          }}
          navigateWorkspace={navigateWorkspace}
          orgData={orgData}
          userData={userData}
        ></AiExtractionInvoice>
      </Modal1>
      <Modal1 isOpen={revisiteOpen} onClose={() => handleRevision(false)}>
        <Revisite
          folder={folder}
          orgData={orgData}
          userData={userData}
          onClose={() => handleRevision(false)}
          onUpdate={() => forcePageReload()}
        ></Revisite>
      </Modal1>
      <Modal1 isOpen={taskOpen} onClose={() => setTaskOpen(false)}>
        <AddTask
          folder={folder}
          orgData={orgData}
          userData={userData}
          onClose={() => setTaskOpen(false)}
          onUpdate={() => forcePageReload()}
        ></AddTask>
      </Modal1>
      <Modal1 isOpen={rdvopen} onClose={() => handleRDV(false)}>
        <RDV
          folder={folder}
          orgData={orgData}
          onClose={() => handleRDV(false)}
          onUpdate={() => forcePageReload()}
        ></RDV>
      </Modal1>
      <Modal1 isOpen={modifThermOpen} onClose={() => handleModifTherm(false)}>
        <ModifThermique
          folder={folder}
          orgData={orgData}
          userData={userData}
          onClose={() => handleModifTherm(false)}
          onUpdate={() => forcePageReload()}
          onOpenEmailModal={() => handleSetEmailModalOpen(true, true)}
        ></ModifThermique>
      </Modal1>
      <Modal1 isOpen={convertOpen} onClose={() => setConvertOpen(false)}>
        <ConvertBasic
          folder={folder}
          orgData={orgData}
          onClose={() => setConvertOpen(false)}
          onUpdate={() => forcePageReload()}
          userData={userData}
        ></ConvertBasic>
      </Modal1>
      <Modal1 isOpen={conformityOpen} onClose={() => handleConformity(false)}>
        <Conformity
          folder={folder}
          orgData={orgData}
          onClose={() => setConformityOpen(false)}
          onUpdate={() => forcePageReload()}
        ></Conformity>
      </Modal1>
      <Modal1
        isOpen={intermediaryOpen}
        onClose={() => setIntermediaryOpen(false)}
      >
        <Intermediary
          folder={folder}
          orgData={orgData}
          onClose={() => setIntermediaryOpen(false)}
          onUpdate={() => forcePageReload()}
        ></Intermediary>
      </Modal1>
      <Modal1 isOpen={docRequestOpen} onClose={() => setDocRequestOpen(false)}>
        <div className="bg-white rounded-xl w-fit max-w-full h-fit max-h-[80vh] flex flex-col">
          <div className="text-h2 text-shadow_50 border-b-1 p-4 flex-shrink-0">
            Sélectionner les documents à demander
          </div>
          <div className="flex flex-col gap-3 w-c400 p-4 overflow-auto flex-1">
            {folderDocuments.length > 0 ? (
              folderDocuments.map((doc, index) => {
                const docName =
                  doc.name || doc.title || `Document ${index + 1}`;
                const docId = doc.id;
                const isChecked = localMissingDocNames.includes(docName);
                const isDone = doc.state === "done";

                return (
                  <div
                    key={index}
                    className={`flex flex-row items-center gap-2 p-2 rounded-md border ${
                      isDone
                        ? "bg-green-50 border-green-200"
                        : "bg-yellow-50 border-yellow-200"
                    }`}
                  >
                    <CheckBoxGrey
                      checked={isChecked}
                      onChange={(checked) => {
                        if (checked) {
                          setLocalMissingDocNames([
                            ...localMissingDocNames,
                            docName,
                          ]);
                          setLocalMissingDocIds([...localMissingDocIds, docId]);
                        } else {
                          setLocalMissingDocNames(
                            localMissingDocNames.filter(
                              (name) => name !== docName
                            )
                          );
                          setLocalMissingDocIds(
                            localMissingDocIds.filter((id) => id !== docId)
                          );
                        }
                      }}
                    />
                    <div className="flex flex-col flex-1">
                      <div
                        className={`text-h4 font-medium ${
                          isDone ? "text-green-800" : "text-yellow-800"
                        }`}
                      >
                        {docName}
                      </div>
                      {doc.description && (
                        <div className="text-h5 text-shadow_50 mt-1">
                          {doc.description}
                        </div>
                      )}
                    </div>
                    <div
                      className={`px-2 py-1 rounded text-h5 ${
                        isDone
                          ? "bg-green-100 text-green-700"
                          : "bg-yellow-100 text-yellow-700"
                      }`}
                    >
                      {isDone ? "Complété" : "En attente"}
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="text-h4 text-shadow_50">
                Aucun document trouvé dans ce dossier
              </div>
            )}
          </div>
          <div className="flex flex-row justify-end gap-2 p-4 border-t-1 flex-shrink-0">
            <SecondaryButton onClick={() => setDocRequestOpen(false)}>
              Annuler
            </SecondaryButton>
            <PrimaryButton
              onClick={handleDocumentSelectionConfirm}
              disabled={localMissingDocNames.length === 0}
            >
              Continuer ({localMissingDocNames.length} document
              {localMissingDocNames.length > 1 ? "s" : ""} sélectionné
              {localMissingDocNames.length > 1 ? "s" : ""})
            </PrimaryButton>
          </div>
        </div>
      </Modal1>
      <DepotCILModal
        isOpen={depotCILOpen}
        onClose={() => setDepotCILOpen(false)}
        folder={folder}
      />
      <PartnerSelectionModal
        isOpen={partnerSelectionOpen}
        onClose={() => setPartnerSelectionOpen(false)}
        folder={folder}
        onConfirm={createCarnet}
        loading={loadingCarnet}
      />
      <PrimaryButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <Row x={10}>
          Actions <Icon1 icon_name="menu" fill="white"></Icon1>
        </Row>
      </PrimaryButton>
      {anchorEl && (
        <div>
          <div
            className=" fixed top-0 left-0  bg-transparent h-screen w-screen z-10  "
            onClick={handleClose}
          ></div>
          <div
            id="basic-menu"
            open={open}
            onClose={handleClose}
            className={`bg-white ${isVisible ? "scale-100 opacity-100" : "scale-95 opacity-0"} transition-all duration-300  w-fit flex-row flex rounded-lg shadow-2xl shadow-shadow_25 l fixed z-20 py-3 px-1   ${isFolderAdmin(orgData, folder) && !stick_left ? "right-10  2.8xl:right-auto" : ""}`}
          >
            <div
              className={` flex flex-col ${isFolderAdmin(orgData, folder) ? " w-c300 " : "w-c250"}`}
            >
              <div className="pl-4 pb-2 text-h3 font-light text-pr bg-transparent text-shadow_50">
                ACTIONS RAPIDES
              </div>
              {vision?.state != "archived" && (
                <div className="group  w-full">
                  <div
                    className={`
                    ${!workspaceData ? "  group-hover:hidden block " : ""}
                  `}
                  >
                    <MenuItemBlock onClick={handleArchive}>
                      <div className="flex flex-grow w-full  flex-row text-h3">
                        <Icon1
                          icon_name="archive"
                          width="18px"
                          height="18px"
                        ></Icon1>
                        <Space x={10} />
                        Archiver
                      </div>
                    </MenuItemBlock>{" "}
                  </div>
                  <div
                    className={`
                    ${!workspaceData ? "  hidden group-hover:block  " : ""}
                  `}
                  >
                    <MenuItemBlock onClick={() => handleArchive("me")}>
                      <div className="flex flex-grow w-full  flex-row text-h3">
                        <Icon1
                          icon_name="archive"
                          width="18px"
                          height="18px"
                        ></Icon1>
                        <Space x={10} />
                        Archiver pour moi
                      </div>
                    </MenuItemBlock>
                    <MenuItemBlock onClick={() => handleArchive("all")}>
                      <div className="flex flex-grow w-full  flex-row text-h3">
                        <Icon1
                          icon_name="archive"
                          width="18px"
                          height="18px"
                        ></Icon1>
                        <Space x={10} />
                        Archiver pour tout le monde
                      </div>
                    </MenuItemBlock>
                  </div>
                </div>
              )}
              {vision?.state == "archived" && (
                <div className="group  w-full">
                  <div
                    className={`
                    ${!workspaceData ? "  group-hover:hidden block " : ""}
                  `}
                  >
                    <MenuItemBlock onClick={handleUnarchive}>
                      <div className="flex flex-grow w-full  flex-row text-h3">
                        <Icon1
                          icon_name="archive"
                          width="18px"
                          height="18px"
                        ></Icon1>
                        <Space x={10} />
                        Désarchiver
                      </div>
                    </MenuItemBlock>{" "}
                  </div>
                  <div
                    className={`
                    ${!workspaceData ? "  hidden group-hover:block  " : ""}
                  `}
                  >
                    <MenuItemBlock onClick={() => handleUnarchive("me")}>
                      <div className="flex flex-grow w-full  flex-row text-h3">
                        <Icon1
                          icon_name="archive"
                          width="18px"
                          height="18px"
                        ></Icon1>
                        <Space x={10} />
                        Désarchiver pour moi
                      </div>
                    </MenuItemBlock>
                    <MenuItemBlock onClick={() => handleUnarchive("all")}>
                      <div className="flex flex-grow w-full  flex-row text-h3">
                        <Icon1
                          icon_name="archive"
                          width="18px"
                          height="18px"
                        ></Icon1>
                        <Space x={10} />
                        Désarchiver pour tout le monde
                      </div>
                    </MenuItemBlock>
                  </div>
                </div>
              )}
              <MenuItemBlock onClick={handleDownload}>
                <div className="flex flex-grow w-full items-center  flex-row text-h3">
                  <Icon1
                    icon_name="download"
                    width="18px"
                    height="18px"
                  ></Icon1>
                  <Space x={10} />
                  Télécharger <Space x={10} />
                  <SmallSpinner loading={loadingDownload}></SmallSpinner>
                </div>
              </MenuItemBlock>
              <MenuItemBlock onClick={actionRefreshCounters}>
                <div className="flex flex-grow w-full  flex-row text-h3">
                  <Icon1 icon_name="restart" width="18px" height="18px"></Icon1>
                  <Space x={10} />
                  Rafraichir actions
                </div>
              </MenuItemBlock>{" "}
              {isFolderAdminOrClient(orgData, folder) && (
                <MenuItemBlock onClick={actionConvert}>
                  <div className="flex flex-grow w-full  flex-row text-h3">
                    <Icon1
                      icon_name="convert"
                      width="18px"
                      height="18px"
                    ></Icon1>
                    <Space x={10} />
                    Changer de prestation
                  </div>
                </MenuItemBlock>
              )}
              <MenuItemBlock
                onClick={() => {
                  if (userData.org_admin) {
                    setAnchorEl(null);
                    setOpenDelete(true);
                  } else {
                    handleClickVariant(
                      "Vous n'avez pas les droits pour effectuer cette action",
                      "error"
                    );
                  }
                }}
              >
                <div className="flex flex-grow w-full  flex-row text-h3 ">
                  <Icon1 icon_name="delete" width="18px" height="18px"></Icon1>
                  <Space x={10} />
                  Supprimer
                </div>
              </MenuItemBlock>
              {isFolderAdmin(orgData, folder) && (
                <div>
                  <MenuItemBlock onClick={actionModify}>
                    <div className="flex flex-grow w-full  flex-row text-h3">
                      <Icon1
                        icon_name="modify"
                        width="18px"
                        height="18px"
                      ></Icon1>
                      <Space x={10} />
                      Modifier
                    </div>
                  </MenuItemBlock>{" "}
                  <MenuItemBlock onClick={actionDuplicate}>
                    <div className="flex flex-grow w-full  flex-row text-h3">
                      <Icon1
                        icon_name="copy"
                        width="18px"
                        height="18px"
                      ></Icon1>
                      <Space x={10} />
                      Dupliquer
                    </div>
                  </MenuItemBlock>
                  {false && (
                    <MenuItemBlock onClick={handleValidateAll}>
                      <div className="flex flex-grow w-full  flex-row text-h3">
                        <Icon1
                          icon_name="done2"
                          width="18px"
                          height="18px"
                        ></Icon1>
                        <Space x={10} />
                        Valider tous les documents
                      </div>
                    </MenuItemBlock>
                  )}
                </div>
              )}
              <div className="pl-4 pt-2 border-t-1 mt-2 pb-2 text-h3 font-light text-pr bg-transparent text-shadow_50">
                COLLABORATEURS
              </div>
              <MenuItemBlock
                onClick={() =>
                  masterData?.config?.planning?.enable_rdv
                    ? navigateWorkspace("/planning-rdv?folder_id=" + folder.id)
                    : setRDVOpen(true)
                }
              >
                <div className="flex flex-grow w-full  flex-row text-h3">
                  <Icon1
                    icon_name="planning"
                    width="18px"
                    height="18px"
                  ></Icon1>
                  <Space x={10} />
                  {"Demander un " +
                    (folder.dateintervention ? "nouveau " : "") +
                    "RDV"}
                </div>
              </MenuItemBlock>
              {particulierActivated(folder) && (
                <MenuItemBlock onClick={handleNotifyParticulier}>
                  <div className="flex flex-grow w-full  flex-row text-h3">
                    <Icon1
                      icon_name="cloche"
                      width="18px"
                      height="18px"
                    ></Icon1>
                    <Space x={10} />
                    Inviter le particulier
                  </div>
                </MenuItemBlock>
              )}{" "}
              {particulierActivated(folder) && (
                <MenuItemBlock
                  onClick={() => {
                    handleClickVariant(
                      "Lien d'invitation copié dans le presse-papier",
                      "success"
                    );
                    navigator.clipboard.writeText(
                      "https://web.hexagone.expert/folderportal/" + folder.id
                    );
                  }}
                >
                  <div className="flex flex-grow w-full  flex-row text-h3">
                    <Icon1 icon_name="link" width="18px" height="18px"></Icon1>
                    <Space x={10} />
                    Copier le lien d'invitation
                  </div>
                </MenuItemBlock>
              )}
              {folderHasCarnet(folder) &&
                hasAccessToCarnet(orgData, carnetDetails) &&
                isFolderAdmin(orgData, folder) && (
                  <MenuItemBlock
                    onClick={() => {
                      handleNavigateCarnet();
                      setAnchorEl(null);
                    }}
                  >
                    <div className="flex flex-grow w-full  flex-row text-h3">
                      <Icon1 icon_name="hexagone-logement" size={20}></Icon1>
                      <Space x={10} />
                      Accéder au CIL
                    </div>
                  </MenuItemBlock>
                )}
              {folderHasCarnet(folder) &&
                hasAccessToCarnet(orgData, carnetDetails) &&
                !isFolderAdmin(orgData, folder) && (
                  <MenuItemBlock
                    onClick={() => {
                      handleNavigateCarnet();
                      setAnchorEl(null);
                    }}
                  >
                    <div className="flex flex-grow w-full  flex-row text-h3">
                      <Icon1 icon_name="hexagone-logement" size={20}></Icon1>
                      <Space x={10} />
                      Accéder au CIL
                    </div>
                  </MenuItemBlock>
                )}
              {folderHasCarnet(folder) &&
                hasAccessToCarnet(orgData, carnetDetails) &&
                !isFolderAdmin(orgData, folder) && (
                  <MenuItemBlock
                    onClick={() => {
                      setDepotCILOpen(true);
                      setAnchorEl(null);
                    }}
                  >
                    <div className="flex flex-grow w-full  flex-row text-h3">
                      <Icon1 icon_name="hexagone-logement" size={20}></Icon1>
                      <Space x={10} />
                      Déposer dans le CIL
                    </div>
                  </MenuItemBlock>
                )}
              {!folderHasCarnet(folder) && canCreateCarnet(orgData, folder) && (
                <MenuItemBlock onClick={handleAddCarnet}>
                  <div className="flex flex-grow w-full items-center flex-row text-h3">
                    <Icon1 icon_name="home" size={20}></Icon1>
                    <Space x={10} />
                    Créer un nouveau CIL <Space x={10} />
                    <SmallSpinner loading={loadingCarnet}></SmallSpinner>
                  </div>
                </MenuItemBlock>
              )}
              <MenuItemBlock
                onClick={() => {
                  setTaskOpen(true);
                  setAnchorEl(null);
                }}
              >
                <div
                  className="flex flex-grow w-full flex-row justify-between items-center text-h3
                              rounded-lg
                            "
                >
                  <div className=" flex w-full justify-between rounded-lg ">
                    <div className="flex flex-grow w-full  flex-row text-h3">
                      <Icon1
                        icon_name="task"
                        width="18px"
                        height="18px"
                      ></Icon1>
                      <Space x={10} />
                      {"Ajouter une tâche"}
                    </div>

                    {/* Arrow */}
                  </div>
                </div>
              </MenuItemBlock>
              {isFolderAdmin(orgData, folder) && (
                <MenuItemBlock onClick={handleDocumentRequest}>
                  <div className="flex flex-grow w-full  flex-row text-h3">
                    <Icon1 icon_name="file" width="18px" height="18px"></Icon1>
                    <Space x={10} />
                    Demander des pièces
                  </div>
                </MenuItemBlock>
              )}
            </div>{" "}
            {isFolderAdmin(orgData, folder) && (
              <div className="flex flex-col w-c300 border-l-1 border-shadow_5">
                {isFolderAdmin(orgData, folder) && (
                  <div>
                    <div className="pl-4 pb-2 text-h3 font-light text-pr bg-transparent text-shadow_50">
                      RAPPORTS
                    </div>
                    {folder.folder_type === "infiltro" && (
                      <div className="relative" onClick={handleRTBatiment}>
                        <MenuItemBlock>
                          <div className="flex flex-grow w-full flex-row justify-between items-center text-h3">
                            <div className="flex flex-row items-center">
                              <Icon1
                                icon_name="rtb"
                                width="18px"
                                height="18px"
                              />
                              <Space x={10} />
                              Générer rapport RT Bâtiment
                            </div>
                            <Icon1
                              icon_name="chevron-right"
                              width="14px"
                              height="14px"
                            />{" "}
                            {/* Arrow */}
                          </div>
                        </MenuItemBlock>

                        {/* Submenu positioned to the right */}
                      </div>
                    )}
                    {folder.folder_type === "infiltro" && (
                      <MenuItemBlock onClick={() => handleModifTherm(true)}>
                        <div className="flex flex-grow w-full  flex-row text-h3">
                          <Icon1
                            icon_name="restauration"
                            width="18px"
                            height="18px"
                          ></Icon1>
                          <Space x={10} />
                          Demander mise à jour thermique
                        </div>
                      </MenuItemBlock>
                    )}
                    {folder.folder_type === "infiltro" &&
                      (folder.revisions === null ||
                        folder.revisions === undefined) && (
                        <MenuItemBlock onClick={() => handleTagRevision(true)}>
                          <div className="flex flex-grow w-full  flex-row text-h3">
                            <Icon1
                              icon_name="tag"
                              width="18px"
                              height="18px"
                            ></Icon1>
                            <Space x={10} />
                            Prévoir une revisite (tag)
                          </div>
                        </MenuItemBlock>
                      )}
                    {folder.folder_type === "infiltro" &&
                      folder.revisions !== null &&
                      folder.revisions !== undefined && (
                        <MenuItemBlock onClick={() => handleTagRevision(false)}>
                          <div className="flex flex-grow w-full  flex-row text-h3">
                            <Icon1
                              icon_name="tag"
                              width="18px"
                              height="18px"
                            ></Icon1>
                            <Space x={10} />
                            Retirer l'indication revisite
                          </div>
                        </MenuItemBlock>
                      )}
                    {folder.folder_type === "infiltro" && (
                      <MenuItem onClick={() => handleRevision(true)}>
                        <div className="flex flex-grow w-full  flex-row text-h3">
                          <Icon1
                            icon_name="restauration"
                            width="18px"
                            height="18px"
                          ></Icon1>
                          <Space x={10} />
                          Créer une revisite
                        </div>
                      </MenuItem>
                    )}
                    <MenuItemBlock onClick={handleNonConforme}>
                      <div className="flex flex-grow w-full  flex-row text-h3">
                        <Icon1
                          icon_name={
                            folder.conforme === false ? "done" : "warning"
                          }
                          width="18px"
                          height="18px"
                        ></Icon1>
                        <Space x={10} />
                        {folder.conforme === false
                          ? "Passer en conforme"
                          : "Passer en non conforme"}
                      </div>
                    </MenuItemBlock>{" "}
                    <MenuItemBlock onClick={handleUnlockRapport}>
                      <div className="flex flex-grow w-full  flex-row text-h3 items-center">
                        <Icon1
                          icon_name="done2"
                          width="18px"
                          height="18px"
                        ></Icon1>
                        <Space x={10} />
                        {folder.reglement_state === "done"
                          ? "Retirer le marquage "
                          : "Passer en "}
                        finalisé
                        {loadingUnlock && (
                          <SmallSpinner
                            margin={4}
                            size={20}
                            loading={true}
                          ></SmallSpinner>
                        )}
                      </div>
                    </MenuItemBlock>
                    {isFolderAdmin(orgData, folder) &&
                      folder.folder_type === "infiltro" && (
                        <>
                          <MenuItemBlock
                            onClick={() => {
                              setIntermediaryOpen(true);
                              setAnchorEl(null);
                            }}
                          >
                            <div className="flex flex-col gap-1">
                              <div className="flex flex-grow w-full  flex-row text-h3">
                                <Icon1
                                  icon_name="file-success"
                                  size={20}
                                ></Icon1>
                                <Space x={10} />
                                Générer rapport test intermédiaire
                              </div>
                            </div>
                          </MenuItemBlock>
                          <MenuItemBlock
                            onClick={() => {
                              setConformityOpen(true);
                              setAnchorEl(null);
                            }}
                          >
                            <div className="flex flex-col gap-1">
                              <div className="flex flex-grow w-full  flex-row text-h3">
                                <Icon1 icon_name="file-error" size={20}></Icon1>
                                <Space x={10} />
                                Générer rapport de contrôle
                              </div>
                            </div>
                          </MenuItemBlock>
                        </>
                      )}{" "}
                    {isFolderAdmin(orgData, folder) && (
                      <div
                        className="relative"
                        onClick={handleFacturePennylane}
                      >
                        <MenuItemBlock>
                          <div className="flex flex-grow w-full  flex-row text-h3">
                            <Icon1
                              icon_name="pennylane"
                              width="18px"
                              height="18px"
                              fill="black"
                            />
                            <Space x={12} />
                            Générer facture pennylane
                          </div>
                        </MenuItemBlock>
                      </div>
                    )}
                    {isFolderAdmin(orgData, folder) && userData.admin && (
                      <div
                        className="relative"
                        onClick={() => handleAiExcelComparatif()}
                      >
                        <MenuItemBlock ai={true}>
                          <div className="flex flex-grow w-full  flex-row text-h3">
                            <Icon1
                              icon_name="excel"
                              width="18px"
                              height="18px"
                              fill="black"
                            />
                            <Space x={12} />
                            Générer excel comparatif
                          </div>
                        </MenuItemBlock>
                      </div>
                    )}{" "}
                    {isFolderAdmin(orgData, folder) && userData.admin && (
                      <div
                        className="relative"
                        onClick={() => handleAiExtractionInvoice()}
                      >
                        <MenuItemBlock ai={true}>
                          <div className="flex flex-grow w-full  flex-row text-h3">
                            <Icon1
                              icon_name="brain"
                              width="18px"
                              height="18px"
                              fill="black"
                            />
                            <Space x={12} />
                            Extraction IA
                          </div>
                        </MenuItemBlock>
                      </div>
                    )}
                    <div className="pl-4 pb-2 mt-2 text-h3 pt-2 border-t-1 font-light text-pr bg-transparent text-shadow_50">
                      PLANNING
                    </div>
                    {folder.intervention_realisee == false && (
                      <MenuItemBlock>
                        <div className="flex w-fit flex-col">
                          <div
                            className="flex flex-grow w-full  flex-row text-h3"
                            onClick={handleSetInterventionRealisee}
                          >
                            <Icon1
                              icon_name="done"
                              width="18px"
                              height="18px"
                            ></Icon1>
                            <Space x={10} />
                            Passer en intervention réalisée
                          </div>
                        </div>
                      </MenuItemBlock>
                    )}
                    {folder.intervention_realisee == true && (
                      <MenuItemBlock>
                        <div className="flex w-fit flex-col">
                          <div
                            className="flex flex-grow w-full  flex-row text-h3"
                            onClick={handleSetInterventionNOTRealisee}
                          >
                            <Icon1
                              icon_name="restart"
                              width="18px"
                              height="18px"
                            ></Icon1>
                            <Space x={10} />
                            Repasser en intervention non réalisée
                          </div>
                        </div>
                      </MenuItemBlock>
                    )}
                    <MenuItemBlock>
                      <div className="flex w-fit flex-col">
                        <div
                          onClick={handleChangeInterventionDate}
                          className="flex flex-grow w-full  flex-row text-h3"
                        >
                          <Icon1
                            icon_name="date"
                            width="18px"
                            height="18px"
                          ></Icon1>
                          <Space x={10} />
                          Changer la date d'intervention
                        </div>
                      </div>
                    </MenuItemBlock>
                    <Space y={10} />
                  </div>
                )}
              </div>
            )}
          </div>{" "}
        </div>
      )}
    </div>
  );
}

export const MenuItemBlock = ({ onClick, children, ai }) => {
  return (
    <div
      onClick={onClick}
      className={`cursor-pointer
        ${ai ? "hover:bg-gradient-to-tr from-cyan-100 to-pink-100 via-indigo-100    " : ""}
        
         flex flex-row  px-4 py-1.5 hover:bg-gray-100`}
    >
      {children}
    </div>
  );
};
